export function luhnValidator(value: string): boolean {
    const digitsToCompare = value.slice(0, value.length - 1);
    const lastDigit = value.slice(value.length - 1);

    const finalDigit = calculateLuhnFinalDigit(digitsToCompare);

    return finalDigit === parseInt(lastDigit);
}

function calculateLuhnFinalDigit(siret: string): number {
    let sum = 0;
    let even = true;

    for (let index = siret.length - 1; index >= 0; --index) {
        let digit = parseInt(siret[index] ?? '0');
        if (even) {
            digit <<= 1;
        }

        if (digit > 9) {
            digit -= 9;
        }

        sum += digit;
        even = !even;
    }
    return (10 - (sum % 10)) % 10;
}
